import React /* [tutorial disabled] , { useEffect } */ from "react";
import { Activity } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
// [tutorial disabled] import { driver } from "driver.js";
// [tutorial disabled] import "driver.js/dist/driver.css";
// [tutorial disabled] import { useApiFetch } from "src/lib/api";

export default function DeviceList({ devices, onDeviceClick }) {
  // [tutorial disabled] const apiFetch = useApiFetch();

  // [tutorial disabled] const disableTutorial = async () => {
    // [tutorial disabled] try {
      // [tutorial disabled] await apiFetch("/auth/disable-tutorial", { method: "POST" });
    // [tutorial disabled] } catch (error) {
      // [tutorial disabled] console.error("Error disabling tutorial:", error);
    // [tutorial disabled] }
  // [tutorial disabled] };
  
  // [tutorial disabled] useEffect(() => {
    // [tutorial disabled] let intervalId = null;

    // [tutorial disabled] const checkForTutorialReady = () => {
      // [tutorial disabled] let step = localStorage.getItem("driver-tutorial-step");
      // [tutorial disabled] const el = document.querySelector("#device-list");

      // [tutorial disabled] if (step === "device-list" && el) {
        // [tutorial disabled] clearInterval(intervalId); 
        // [tutorial disabled] startDriver(); 

        // [tutorial disabled] setTimeout(() => {
          // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);
        // [tutorial disabled] }, 1000);
      // [tutorial disabled] }
    // [tutorial disabled] };

    // [tutorial disabled] const startDriver = () => {
      // [tutorial disabled] const driverObj = driver({
        // [tutorial disabled] steps: [
          // [tutorial disabled] {
            // [tutorial disabled] element: "#device-list",
            // [tutorial disabled] popover: {
              // [tutorial disabled] title: "Device List",
              // [tutorial disabled] description: "This card shows the active device list, device can be selected and see their positions from a closer position on the map",
              // [tutorial disabled] prevBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText:  `
                  // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                  // [tutorial disabled] </svg>
                // [tutorial disabled] `,
              // [tutorial disabled] onNextClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "navbar");
              // [tutorial disabled] },
              // [tutorial disabled] onCloseClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
                // [tutorial disabled] driverObj.destroy();
                // [tutorial disabled] disableTutorial();
              // [tutorial disabled] },
              // [tutorial disabled] onPrevClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "active");
              // [tutorial disabled] },  
            // [tutorial disabled] },
            // [tutorial disabled] onDeselected: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onDestroyed: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onHighlighted: () => {
              // [tutorial disabled] const enablePrev = () => {
                // [tutorial disabled] const prevBtn = document.querySelector('.driver-popover-prev-btn');
                // [tutorial disabled] if (prevBtn) {
                  // [tutorial disabled] prevBtn.removeAttribute("disabled");
                  // [tutorial disabled] prevBtn.classList.remove('driver-popover-btn-disabled');
                  // [tutorial disabled] clearInterval(retry);
                // [tutorial disabled] }
              // [tutorial disabled] };

              // [tutorial disabled] const retry = setInterval(enablePrev, 100);
              // [tutorial disabled] setTimeout(() => clearInterval(retry), 1000);
            // [tutorial disabled] },
          // [tutorial disabled] },
        // [tutorial disabled] ],
      // [tutorial disabled] });

      // [tutorial disabled] driverObj.drive();
    // [tutorial disabled] };

    // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);

    // [tutorial disabled] return () => {
      // [tutorial disabled] if (intervalId) clearInterval(intervalId);
    // [tutorial disabled] };
  // [tutorial disabled] }, []);

  return (
    <Card className="device-list-card w-full max-w-[316px]" id="device-list">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-base font-bold">
          Device List
          {devices?.length > 0 && (
            <span className="ml-2 text-sm font-normal text-muted-foreground">({devices.length})</span>
          )}
        </CardTitle>
        <Activity className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent className="device-list-items max-h-64 overflow-y-auto">
        {(devices ?? []).length === 0 && (
          <p className="m-0 py-1 text-sm text-muted-foreground">No devices found.</p>
        )}
        {(devices ?? []).map((device, index) => (
          <div key={index} className="device-list-row flex justify-between py-1">
            <button
              type="button"
              title={device.name}
              onClick={() => onDeviceClick && onDeviceClick(device)}
            >
              {/* {device.name} */}

              {/* device?.name?.includes("-") ? device.name.slice(device.name.lastIndexOf("-") + 1) :  */device.name}

            </button>
            {/* <span>{device.status}</span> */}
            {device.status === "offline" && (
              <span className="text-destructive">OFF</span>
            )}
            {device.status === "online" && (
              <span className="text-active">ON</span>
            )}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}